const oauthStateBaseUrl = 'https://oauth-state.invalid';

export function getRouteFromOAuthState(
  state: string | null | undefined
): string | null {
  if (!state || state === 'undefined' || state === 'null') {
    return null;
  }

  let decodedState: string;
  try {
    decodedState = decodeURIComponent(state);
  } catch {
    return null;
  }

  if (
    /^[a-z][a-z\d+.-]*:/i.test(decodedState) &&
    !/^https?:/i.test(decodedState)
  ) {
    return null;
  }

  try {
    const url = new URL(decodedState, oauthStateBaseUrl);
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}
